import { useMemo } from "react";
import { ChakraFlex as Flex } from "@airhelp/react-ui-components";
import getPaginationPages from "./utility";
import type { PaginationProps } from "./Pagination.d";
import PagesList from "./PagesList";
import NextButton from "./NextButton";
import PrevButton from "./PrevButton";

const Pagination = ({
  previousPage,
  canPreviousPage,
  pages,
  nextPage,
  canNextPage,
  goToPage,
  currentPage,
  position = "flex-start",
}: PaginationProps) => {
  const memoPages = useMemo(() => getPaginationPages(pages, currentPage), [currentPage, pages]);

  return (
    <Flex color="primary.500" align="center" justify={position} data-testid="pagination">
      <PrevButton previousPage={previousPage} canPreviousPage={canPreviousPage} />
      <PagesList pages={memoPages} onPageClick={goToPage} currentPage={currentPage} />
      <NextButton nextPage={nextPage} canNextPage={canNextPage} />
    </Flex>
  );
};

export default Pagination;
